import { makeStyles } from 'tss-react/mui';
import { colors, spacing } from '../../styles/jss/variables';
import { generateHeadingStyles } from '../../styles/jss/common';
const useStyles = makeStyles()((theme, params, classes) => {
    var _a;
    return ({
        container: {
            display: 'flex',
            position: 'relative',
            overflow: 'hidden',
        },
        ffImage: {},
        content: {
            position: 'absolute',
            [theme.breakpoints.up('sm')]: {
                position: 'relative',
            },
        },
        positionLeft: {
            [theme.breakpoints.up('sm')]: {
                flexDirection: 'row-reverse',
            },
            [`&  img`]: {
                objectPosition: 'center ',
                objectFit: 'contain',
                [theme.breakpoints.up('sm')]: {
                    objectPosition: 'right bottom',
                    maxHeight: 'unset',
                },
            },
            [`& .${classes.imageCover}`]: {
                '& img': {
                    objectFit: 'cover',
                },
            },
            [`&.${classes.ffHomeHeroBannerGalleryContainer} .${classes.contentInner}`]: {
                [theme.breakpoints.down('sm')]: {
                    alignItems: 'start',
                    '& p': {
                        marginLeft: 0,
                    },
                },
            },
        },
        positionRight: {
            [theme.breakpoints.up('sm')]: {
                flexDirection: 'row',
                [`& .${classes.content}`]: {
                    justifyContent: 'right',
                },
            },
            [`&  img`]: {
                objectPosition: 'center bottom',
                height: '330px',
                maxHeight: '330px',
                objectFit: 'contain',
                [theme.breakpoints.up('sm')]: {
                    objectPosition: 'bottom left',
                    maxHeight: 'unset',
                },
            },
            [`& .${classes.imageCover}`]: {
                '& img': {
                    objectFit: 'cover',
                },
            },
        },
        positionCenter: {
            [theme.breakpoints.up('sm')]: {
                justifyContent: 'center',
                [`& .${classes.content}`]: {
                    width: '100%',
                },
                [`& .${classes.ffImage}`]: {
                    '& img': {
                        objectPosition: 'bottom',
                        objectFit: 'contain',
                    },
                },
                [`& .${classes.ffGalleryImageCover}`]: {
                    '& img': {
                        objectFit: 'cover',
                    },
                },
                [`&.${classes.ffHomeHeroBannerGalleryContainer}`]: {
                    '& div[data-testid="linkContainer"]': {
                        justifyContent: 'center',
                    },
                },
            },
        },
        heading: Object.assign({}, generateHeadingStyles(theme, spacing, colors)),
        subheading: Object.assign(Object.assign(Object.assign({}, theme.typography.small_bold), theme.typographySpacing.none), { textAlign: 'center', [theme.breakpoints.up('sm')]: {
                display: 'block',
                textAlign: 'left',
            }, [theme.breakpoints.up('xl')]: Object.assign(Object.assign(Object.assign({}, theme.typography.large_bold), theme.typographySpacing.none), { marginBottom: spacing.medium }) }),
        message: Object.assign(Object.assign({ marginTop: spacing.small, textAlign: 'center' }, theme.typography.xxs_regular), { paddingBottom: '6px', marginBottom: spacing.small, '& p': Object.assign({}, theme.typography.xxs_regular) }),
        linkContainer: {
            display: 'block',
            [theme.breakpoints.up('sm')]: {
                display: 'flex',
                flexDirection: 'row',
                gap: spacing.medium,
            },
            '& button': { width: '100%' },
        },
        hideOnMobile: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'flex',
            },
        },
        ffLinkContainer: {
            position: 'absolute',
            bottom: spacing.medium,
            left: 0,
            right: 0,
            marginLeft: '20px',
            marginRight: '20px',
        },
        outsideLinkContainer: {
            marginLeft: '20px',
            marginRight: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexDirection: 'column',
            marginTop: spacing.medium,
            [theme.breakpoints.up('sm')]: {
                display: 'none',
            },
        },
        links: {
            width: '100%',
            display: 'flex',
            marginBottom: spacing.small,
            '& button': {
                whiteSpace: 'pre-wrap',
            },
            [theme.breakpoints.up('sm')]: {
                flexDirection: 'column',
                marginBottom: 0,
                width: '50%',
                '& :last-child': {
                    marginRight: 0,
                },
            },
            [theme.breakpoints.up('md')]: {
                width: '50%',
                marginRight: spacing.medium,
                '& button': { width: '100%' },
                '&:not(:last-child)': {
                    marginBottom: '0',
                    marginRight: spacing.medium,
                },
            },
            [theme.breakpoints.up('md')]: {
                width: '46%',
            },
        },
        headingLine: {
            whiteSpace: 'nowrap',
            alignSelf: 'flex-start',
            padding: spacing.xs,
            '&:first-child': {
                transform: 'rotate(358deg) translate(5px,5px)',
                transformOrigin: 'bottom left',
            },
        },
        COBALT: {
            backgroundColor: colors.cobalt[500],
        },
        JADE: {
            backgroundColor: colors.jade[500],
        },
        WILD_EXOTIC: {
            backgroundColor: colors.wildExotic[500],
        },
        image: {
            '& img': {
                // flying flowers image positioned at the bottom
                objectPosition: 'bottom right',
                objectFit: 'cover',
            },
        },
        ffMobileSubMessageContainer: {
            display: 'none',
            [theme.breakpoints.up('sm')]: {
                display: 'flex',
                justifyContent: 'center',
                minHeight: 'initial',
                height: 'initial',
            },
        },
        topsubMessageContainer: {
            display: 'flex',
            minHeight: 'initial',
            height: 'initial',
            [theme.breakpoints.up('sm')]: {
                display: 'none ',
            },
        },
        ffCenterContentInner: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'initial',
            alignItems: 'center',
            [theme.breakpoints.up('md')]: {
                justifyContent: 'center',
            },
            [`& a`]: {
                width: '100%',
            },
        },
        centerHeading: {
            alignSelf: 'center',
        },
        outsideShowTrustpilotWidget: {
            minHeight: '60px',
            display: 'flex',
            marginTop: spacing.small,
            marginLeft: '20px',
            marginRight: '20px',
            padding: '18px',
            justifyContent: 'center',
            [theme.breakpoints.up('md')]: {
                display: 'none',
            },
        },
        contentInner: {
            margin: `${spacing.small} 20px 10px`,
            [theme.breakpoints.between('sm', 'md')]: {
                marginBottom: '10px',
            },
            [theme.breakpoints.up('md')]: {
                margin: spacing.xxl,
            },
            [theme.breakpoints.up('xl')]: {
                margin: '128px',
            },
            '& :last-child': {
                marginBottom: 0,
            },
        },
        displayContentCenter: {
            [theme.breakpoints.down('sm')]: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
        },
        imageCover: {},
        mobilePositionOver: {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column-reverse',
                placeContent: 'start',
                [`& .${classes.image}`]: {
                    position: 'absolute',
                    width: '100%',
                    height: '100%',
                },
                [`& .${classes.ffImage}`]: {
                    maxHeight: '335px',
                },
            },
        },
        mobilePositionBottom: {
            [theme.breakpoints.down('sm')]: {
                flexDirection: 'column',
            },
        },
        adjustFFImageContainer: {
            '& img': {
                [theme.breakpoints.down('sm')]: {
                    objectFit: 'contain',
                    objectPosition: 'center bottom',
                    height: (params === null || params === void 0 ? void 0 : params.linksCount) === 1 ? '268px' : '330px',
                    maxHeight: (params === null || params === void 0 ? void 0 : params.linksCount) === 1 ? '268px' : '330px',
                },
            },
        },
        adjustContent: {
            position: 'relative',
        },
        ffGalleryImageCover: {},
        ffGalleryLinkContainer: {
            maxWidth: '650px',
        },
        ffHomeHeroBannerGalleryContainer: {
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'start',
                minHeight: '444px',
                height: '444px',
                [`& .${classes.ffImage}`]: {
                    maxHeight: 'unset',
                },
                [`& .${classes.content}`]: {
                    position: 'absolute',
                },
                [`& .${classes.ffGalleryOutsideLinkContainer}`]: {
                    position: 'absolute',
                    bottom: spacing.medium,
                    left: 0,
                    right: 0,
                    '& a:last-child': {
                        marginBottom: 0,
                    },
                },
            },
            '& div[data-testid="linkContainer"]': {
                [theme.breakpoints.up('sm')]: {
                    width: '100%',
                    display: 'flex',
                },
            },
            [`& .${classes.ffGalleryLinkContainer}`]: {
                maxWidth: '650px',
                width: ((_a = params === null || params === void 0 ? void 0 : params.linksCount) !== null && _a !== void 0 ? _a : 0) > 1 ? '100%' : undefined,
                [`& .${classes.links}`]: {
                    width: '100%',
                },
            },
        },
        galleryTitle: {},
        ffGalleryOutsideLinkContainer: {},
        adjustLeftMargin: {
            marginLeft: `${spacing.large}`,
            [theme.breakpoints.up('sm')]: {
                marginLeft: `${spacing.xxl}`,
            },
        },
        adjustRightMargin: {
            marginRight: `${spacing.large}`,
            [theme.breakpoints.up('sm')]: {
                marginRight: `${spacing.xxl}`,
            },
        },
        ffGallerySubMessageHeight: {
            minHeight: '56px',
            height: '56px',
            [theme.breakpoints.up('sm')]: {
                minHeight: '72px',
                height: '72px',
            },
        },
        noBackgroundColor: {
            backgroundColor: 'unset',
        },
    });
});
export default useStyles;
